import { lazyPage } from 'app/client/utilities/lazy';

export default lazyPage(() => import(/* webpackChunkName: "dashboard/index" */ './index'));
